import React, { Component } from 'react';

import {
    Spin,
    Card,
    Statistic,
    Typography,
    Input,
    Button,
    Alert,
    Divider,
    Switch,
    message,
} from 'antd';

import { CheckCircleFilled, CloseCircleFilled, LinkOutlined } from '@ant-design/icons';

import UpgradeBanner from '../../components/UpgradeBanner/UpgradeBanner';

import { useState } from '../../state/StateProvider';

const { Title } = Typography;

class SettingsPage extends Component {
    state = {
        apiKey: null,
        widgetEnabled: null,
    }

    componentDidMount() {
        const { savedApiKey, widgetEnabled } = this.props;
        this.setState({ apiKey: savedApiKey, widgetEnabled });
    }

    verifyApiKey = () => {
        if (!this.state.apiKey) return message.warn('Please provide an API key')
        // console.log('verify api key', this.state.apiKey);
    }

    deactivateApiKey = () => {
        // console.log('deactivate api key');
        this.props.resetApiKey();
    }

    saveWidgetSetting = () => {
        const { widgetEnabled } = this.state;
        this.props.saveSettings({ widget_enabled: JSON.stringify(widgetEnabled) });
    }

    getPlanName = plan => {
        switch(plan) {
            case undefined: return 'None'
            case '': return 'Free';
            case 'starter': return 'Stater';
            case 'standard': return 'Standard';
            case 'portfolio': return 'Portfolio';
            case 'tycoon': return 'Tycoon';
            default: return 'Custom';
        }
    }

    renderPlan = () => {
        const { plan, planCredits, credits, allowedProjects } = this.props.user;
        // console.log(plan, planCredits, credits, allowedProjects);

        return <>
            <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 10 }}>Plan</div>
            <div>
                <div style={{ marginBottom: 10 }}>
                    <div style={{ width: 200, display: "inline-block" }}>Current Plan:</div>
                    <span>{this.getPlanName(plan)}</span>
                </div>
                <div style={{ marginBottom: 10 }}>
                    <div style={{ width: 200, display: "inline-block" }}>Plan Projects:</div>
                    <span>{allowedProjects || 'None'}</span>
                </div>
                <div style={{ marginBottom: 10 }}>
                    <div style={{ width: 200, display: "inline-block" }}>Monthly Credits:</div>
                    {planCredits ? (<span>{credits} remaining of {planCredits}</span>) : 'None'}
                </div>
                <div style={{ marginTop: 20 }}>
                    <Button style={{ marginRight: 10 }}>
                        <a href="https://app.amzwatcher.com/app/account/subscription/" target="_blank">Subscription Details <span aria-hidden="true" className="dashicons dashicons-external" style={{ fontSize: 15, lineHeight: '22px' }}></span></a>
                    </Button>
                    <Button>
                        <a href="https://app.amzwatcher.com/app/pricing/" target="_blank">Change your plan <span aria-hidden="true" className="dashicons dashicons-external" style={{ fontSize: 15, lineHeight: '22px' }}></span></a>
                    </Button>
                </div>
            </div>
        </>
    }

    render() {
        const { apiKey, widgetEnabled } = this.state;
        const { savedApiKey, user, failedFetch, toggleWidgetLoading } = this.props;

        const showBanner = Object.keys(user).length ? user && user.plan === '' : true;
        
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                 <div style={{ width: '100%', marginRight: 25, maxWidth: 800 }}>
                    <Title level={4} style={{ margin: '10px 0 15px 0' }}>Settings</Title>

                    <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 10 }}>Connection</div>
                    <div>
                        {!savedApiKey && !failedFetch && <Alert 
                            message="Don't have an API key? Create a free AMZ Watcher account to get the key" 
                            action={<Button size="small">Create Account</Button>}
                            style={{ marginBottom: 10 }}
                        />}

                        <div style={{ margin: '10px 0' }}>
                            <div style={{ width: 200, display: "inline-block" }}>Status</div>
                            <span >
                                {savedApiKey && !failedFetch ? 
                                    <span><CheckCircleFilled style={{ color: 'green', marginRight: 7 }} />Connected</span> 
                                    : 
                                    <span><CloseCircleFilled style={{ color: 'orange', marginRight: 7 }} />Not Connected</span>
                                }
                            </span>
                        </div>
                        
                        <div style={{ margin: '10px 0' }}>
                            <div style={{ width: 200, display: "inline-block" }}>Your API Key</div>
                            <span>
                                <Input style={{ marginRight: 10, width: 300 }} value={apiKey} onChange={e => this.setState({ apiKey: e.target.value })} type="password" disabled={apiKey} />
                                {!savedApiKey && <Button style={{ marginRight: 10, marginTop: 10 }} onClick={this.verifyApiKey} disabled={!apiKey}>Verify API Key</Button>}
                                {savedApiKey && <Button style={{ marginTop: 10 }} onClick={this.deactivateApiKey} disabled={!savedApiKey}>Reset API Key</Button>}
                            </span>
                        </div>
                       
                        <div style={{ margin: '20px 0' }}>
                            Documentation: <a href="https://amzwatcher.com/knowledge-base/#wordpress-plugin" target="_blank"> How to get an API Key? <span aria-hidden="true" className="dashicons dashicons-external" style={{ fontSize: 15, lineHeight: '22px' }}></span></a>
                        </div>
                    </div>
                    
                    <Divider />
                    {this.renderPlan()}
                    <Divider />
                    <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 10 }}>Widget</div>
                    <div>
                        <div style={{ width: 200, display: "inline-block" }}>Content editor widget:</div>
                        <span>
                            <Switch disabled={!savedApiKey} checked={widgetEnabled} onChange={v => { console.log(v); this.setState({ widgetEnabled: v })}} />
                        </span>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <Button disabled={!savedApiKey} onClick={this.saveWidgetSetting} loading={toggleWidgetLoading}>Save Changes</Button>
                    </div>

                    <Divider />
                    
                </div>
                <div style={{ marginTop: 20 }}>
                    {showBanner && <UpgradeBanner />}
                </div>
            </div>
        );
    }
}

const SettingsPageContainer = () => {
    const { state, apiKey, failedFetch, resetApiKey, saveSettings } = useState();
    const { user, settings, toggleWidgetLoading } = state;

    const widgetEnabled = settings.widget_enabled === 'true' ? true : false;

    return <SettingsPage 
        savedApiKey={apiKey} 
        widgetEnabled={widgetEnabled}
        user={user} 
        resetApiKey={resetApiKey} 
        saveSettings={saveSettings} 
        failedFetch={failedFetch}
        toggleWidgetLoading={toggleWidgetLoading}
    />
}

export default SettingsPageContainer;